import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../../analytics.const';

const { GALLERY } = ANALYTICS_CATEGORIES;

export const triggerGalleryTabClickedEvent = (section: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GALLERY,
		customData: { label: section },
		name: 'dlr_hero_gallery_tab_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
